import { render } from "./404.vue?vue&type=template&id=4fe5fe98"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexandrbukhanov/Documents/Документы — MacBook Air — Alexandr/work/dt-teh/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__